import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';
import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.kiera.actions');
import { OnInit } from '@angular/core';
import { Service } from 'src/libs/portal/season/service';
import { TranslateService } from '@ngx-translate/core';

@Component({
 standalone: false,
 selector: 'wiz-page-kiera-actions',
template: templateSource || '',
    styles: [`

/* file: /opt/app/project/main/.kiera-build/src/app/page.kiera.actions/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PageKieraActionsComponent implements OnInit {
    // Step management: 1 = Select Nodes, 2 = Select Actions & Results
    public currentStep: number = 1;

    // Action definitions (no descriptions)
    public actions: any[] = [
        {
            group: 'Power', items: [
                { label: 'Power On', value: 'power-on' },
                { label: 'Power Off', value: 'power-off' },
                { label: 'Power Cycle', value: 'power-cycle' },
                { label: 'Power Soft Off', value: 'power-soft' },
            ]
        },
        {
            group: 'Boot Device', items: [
                { label: 'UEFI PXE Boot Override (Persistent)', value: 'bootdev-pxe' },
                { label: 'Legacy PXE Boot Override (Persistent)', value: 'bootdev-pxe-legacy' },
                { label: 'Clear Boot Override', value: 'bootdev-clear' },
                { label: 'BIOS Setup', value: 'bootdev-bios' },
            ]
        },
        {
            group: 'Deploy', items: [
                { label: 'Deploy Image', value: 'deploy', hasOptions: true },
                { label: 'Release', value: 'release' },
                { label: 'Commission', value: 'commission' },
            ]
        },
        {
            group: 'Backup', items: [
                { label: 'Safe Backup', value: 'backup-safe' },
                { label: 'Live Backup', value: 'backup-live' },
            ]
        },
        {
            group: 'Info', items: [
                { label: 'Get Power Status', value: 'get-power' },
                { label: 'Get Boot Device', value: 'get-bootdev' },
            ]
        },
        {
            group: 'Script', items: [
                { label: 'Execute Script', value: 'script-execute', hasOptions: true },
            ]
        },
    ];

    private readonly finalResultActions: Set<string> = new Set([
        'power-on',
        'power-off',
        'power-cycle',
        'power-soft',
        'power-reset',
        'bootdev-pxe',
        'bootdev-pxe-legacy',
        'bootdev-clear',
        'bootdev-bios',
        'get-power',
        'get-bootdev',
    ]);

    // Execution matrix: which layers each action touches
    public executionMatrix: any = {
        'power-on':           { ipmi: true, pxe: false, db: false, ssh: false, cloudinit: false },
        'power-off':          { ipmi: true, pxe: false, db: false, ssh: false, cloudinit: false },
        'power-cycle':        { ipmi: true, pxe: false, db: false, ssh: false, cloudinit: false },
        'power-soft':         { ipmi: true, pxe: false, db: false, ssh: false, cloudinit: false },
        'power-reset':        { ipmi: true, pxe: false, db: false, ssh: false, cloudinit: false },
        'bootdev-pxe':        { ipmi: true, pxe: false, db: false, ssh: false, cloudinit: false },
        'bootdev-pxe-legacy': { ipmi: true, pxe: false, db: false, ssh: false, cloudinit: false },
        'bootdev-clear':      { ipmi: true, pxe: false, db: false, ssh: false, cloudinit: false },
        'bootdev-bios':       { ipmi: true, pxe: false, db: false, ssh: false, cloudinit: false },
        'get-power':          { ipmi: true, pxe: false, db: true,  ssh: false, cloudinit: false },
        'get-bootdev':        { ipmi: true, pxe: false, db: false, ssh: false, cloudinit: false },
        'deploy':             { ipmi: true, pxe: true,  db: true,  ssh: false, cloudinit: true },
        'commission-deploy':  { ipmi: true, pxe: true,  db: true,  ssh: false, cloudinit: true },
        'release':            { ipmi: true, pxe: true,  db: true,  ssh: false, cloudinit: false },
        'commission':         { ipmi: true, pxe: true,  db: true,  ssh: false, cloudinit: true },
        'backup-safe':        { ipmi: true, pxe: true,  db: true,  ssh: false, cloudinit: true },
        'backup-live':        { ipmi: true, pxe: true,  db: true,  ssh: false, cloudinit: true },
        'script-execute':     { ipmi: false, pxe: false, db: true, ssh: false, cloudinit: false, agent: true },
    };

    // State transitions: what status changes each action causes
    public stateTransitions: any = {
        'deploy':             { before: '*', after: 'auto commission → deploy / deploy only', success: 'deployed', failure: 'failed' },
        'commission-deploy':  { before: '*', after: 'commissioning → deploying', success: 'deployed', failure: 'failed' },
        'release':            { before: 'deployed / *', after: 'ready', success: 'ready', failure: '-' },
        'commission':         { before: '* / new', after: 'commissioning', success: 'ready', failure: 'failed' },
        'backup-safe':        { before: 'deployed / *', after: 'status: backup', success: 'deploy_status: backed-up', failure: 'failed' },
        'backup-live':        { before: 'deployed / *', after: 'status: backup', success: 'deploy_status: backed-up', failure: 'failed' },
        'power-on':           { before: 'off', after: 'on', success: 'on', failure: '-' },
        'power-off':          { before: 'on', after: 'off', success: 'off', failure: '-' },
        'power-cycle':        { before: 'on', after: 'on', success: 'on', failure: '-' },
        'power-soft':         { before: 'on', after: 'off', success: 'off', failure: '-' },
    };

    public matrixLayers: string[] = ['ipmi', 'pxe', 'db', 'ssh', 'cloudinit', 'agent'];
    public matrixLayerLabels: any = { ipmi: 'IPMI', pxe: 'PXE/GRUB', db: 'DB', ssh: 'SSH', cloudinit: 'Cloud-Init', agent: 'Node Agent (HTTP poll)' };
    public showMatrix: boolean = false;

    // Checked actions in order
    public checkedActions: any[] = [];

    // Options for actions that need them
    public deployForm: any = { image_id: '', rootfs_addr: '' };
    public serverIp: string = '';
    public images: any[] = [];
    public scripts: any[] = [];
    public selectedScriptId: string = '';

    // Node selection
    public nodeTab: string = 'group';
    public groups: any[] = [];
    public clusters: any[] = [];
    public zones: any[] = [];
    public allNodes: any[] = [];
    public nodeSearch: string = '';
    public nodeGroupFilter: string = '';
    public nodePage: number = 1;
    public nodeDump: number = 20;
    public nodeTotal: number = 0;
    public nodePageSizeOptions: number[] = [20, 50];
    public nodeCache: any = {};
    public groupRacks: any = {};
    public resolvedTargetNodes: any[] = [];
    public targetTotal: number = 0;
    private nodeSearchTimer: any = null;
    public selectionDirty: boolean = true;
    public isResolvingTargets: boolean = false;
    private targetResolveToken: number = 0;

    // Include / Exclude
    public includeGroups: Set<number> = new Set();
    public excludeGroups: Set<number> = new Set();
    public includeRacks: Set<string> = new Set();
    public excludeRacks: Set<string> = new Set();
    public includeClusters: Set<number> = new Set();
    public excludeClusters: Set<number> = new Set();
    public includeZones: Set<number> = new Set();
    public excludeZones: Set<number> = new Set();
    public includeNodes: Set<number> = new Set();
    public excludeNodes: Set<number> = new Set();
    public expandedGroups: Set<number> = new Set();

    // Results (per action)
    public actionResults: any[] = [];
    public isRunning: boolean = false;
    public currentRunningAction: string = '';
    public currentRunningIndex: number = -1;

    // Step 2: per-node toggle (which nodes are enabled for execution)
    public step2EnabledNodes: Set<number> = new Set();

    // Recent command groups
    public recentCommands: any[] = [];

    constructor(@Inject( Service) public service: Service,@Inject( TranslateService)  private translate: TranslateService) { }

    public async ngOnInit() {
        await this.service.init();
        await this.loadGroups();
        await this.loadSelectors();
        await this.loadActionCatalog();
        await this.loadNodes();
        await this.loadServerInfo();
        await this.loadRecentCommands();
        await this.service.render();
    }

    public async loadActionCatalog() {
        const { code, data } = await wiz.call("action_catalog");
        if (code !== 200 || !data) return;
        if (data.groups && data.groups.length) {
            this.actions = data.groups;
        }
        if (data.execution_matrix) {
            this.executionMatrix = data.execution_matrix;
        }
        if (data.state_transitions) {
            this.stateTransitions = data.state_transitions;
        }
    }

    public async loadGroups() {
        const { code, data } = await wiz.call("groups");
        if (code === 200) this.groups = data.rows || data || [];
    }

    public async loadSelectors() {
        const { code, data } = await wiz.call("selectors");
        if (code === 200) {
            this.clusters = data?.clusters || [];
            this.zones = data?.zones || [];
        }
    }

    public async loadServerInfo() {
        const { code, data } = await wiz.call("server_info");
        if (code === 200) {
            this.serverIp = data.server_ip || '';
            this.deployForm.rootfs_addr = this.serverIp;
        }
    }

    public async loadNodes() {
        await this.loadNodesPage(1);
    }

    public async loadNodesPage(page: number = 1) {
        this.nodePage = page;
        const { code, data } = await wiz.call("nodes", {
            page: this.nodePage,
            dump: this.nodeDump,
            text: this.nodeSearch,
            group_id: this.nodeGroupFilter,
        });
        if (code === 200) {
            this.allNodes = data.rows || [];
            this.nodeTotal = data.total || 0;
            this.cacheNodes(this.allNodes);
        }
        await this.service.render();
    }

    public async changeNodePageSize() {
        await this.loadNodesPage(1);
    }

    public scheduleNodeSearch() {
        if (this.nodeSearchTimer) clearTimeout(this.nodeSearchTimer);
        this.nodeSearchTimer = setTimeout(async () => {
            await this.loadNodesPage(1);
        }, 300);
    }

    private cacheNodes(rows: any[]) {
        for (const row of rows || []) {
            if (row && row.id != null) this.nodeCache[Number(row.id)] = row;
        }
    }

    public nodeTotalPages() {
        return Math.ceil(this.nodeTotal / this.nodeDump) || 1;
    }

    public nodePageList() {
        const tp = this.nodeTotalPages();
        const current = this.nodePage;
        const pages: number[] = [];
        const start = Math.max(1, current - 2);
        const end = Math.min(tp, current + 2);
        for (let i = start; i <= end; i++) pages.push(i);
        return pages;
    }

    public async loadImages() {
        const { code, data } = await wiz.call("images");
        if (code === 200) this.images = data.rows || [];
        await this.service.render();
    }

    public async loadScripts() {
        const { code, data } = await wiz.call("scripts");
        if (code === 200) this.scripts = data.rows || [];
        await this.service.render();
    }

    public async loadRecentCommands() {
        const { code, data } = await wiz.call("recent_commands");
        if (code === 200) this.recentCommands = data.commands || [];
    }

    // ===== Step Navigation =====
    public async goToStep(step: number) {
        if (step > 2 || step < 1) return;
        if (step === this.currentStep && step === 2 && !this.selectionDirty) return;

        if (step === 2) {
            if (!this.hasAnySelection) return;
            if (this.isResolvingTargets) return;

            const resolveToken = ++this.targetResolveToken;
            this.currentStep = 2;
            this.isResolvingTargets = this.selectionDirty || this.resolvedTargetNodes.length === 0;
            if (this.isResolvingTargets) {
                this.resolvedTargetNodes = [];
                this.targetTotal = 0;
                this.step2EnabledNodes.clear();
                await this.service.render();
            }

            const hasTargets = await this.resolveTargetNodes(resolveToken);
            if (resolveToken !== this.targetResolveToken) return;
            this.isResolvingTargets = false;
            if (!hasTargets) {
                this.currentStep = 1;
                await this.service.render();
                return;
            }

            this.enableAllStep2Nodes();
            await this.service.render();
            return;
        }

        // Back from step 2 → clear step 2 cache
        if (step < this.currentStep) {
            this.targetResolveToken++;
            this.isResolvingTargets = false;
            if (this.currentStep === 2) {
                this.checkedActions = [];
                this.actionResults = [];
                this.deployForm = { image_id: '', rootfs_addr: this.serverIp };
                this.selectedScriptId = '';
                this.isRunning = false;
                this.currentRunningAction = '';
                this.currentRunningIndex = -1;
                this.step2EnabledNodes.clear();
            }
        }
        this.currentStep = step;
        await this.service.render();
    }

    private enableAllStep2Nodes() {
        this.step2EnabledNodes.clear();
        for (const n of this.targetNodes) {
            this.step2EnabledNodes.add(n.id);
        }
    }

    public async toggleStep2Node(nodeId: number) {
        if (this.step2EnabledNodes.has(nodeId)) {
            this.step2EnabledNodes.delete(nodeId);
        } else {
            this.step2EnabledNodes.add(nodeId);
        }
        await this.service.render();
    }

    public async toggleAllStep2Nodes() {
        if (this.step2EnabledNodes.size === this.targetNodes.length) {
            this.step2EnabledNodes.clear();
        } else {
            for (const n of this.targetNodes) {
                this.step2EnabledNodes.add(n.id);
            }
        }
        await this.service.render();
    }

    public get step2ActiveNodes(): any[] {
        return this.targetNodes.filter((n: any) => this.step2EnabledNodes.has(n.id));
    }

    // ===== Action Checkbox =====
    public isActionChecked(value: string): boolean {
        return this.checkedActions.some((a: any) => a.value === value);
    }

    public getActionOrder(value: string): number {
        const idx = this.checkedActions.findIndex((a: any) => a.value === value);
        return idx >= 0 ? idx + 1 : -1;
    }

    public async toggleAction(item: any) {
        const idx = this.checkedActions.findIndex((a: any) => a.value === item.value);
        if (idx >= 0) {
            this.checkedActions.splice(idx, 1);
        } else {
            this.checkedActions.push({ ...item });
            if ((item.value === 'deploy' || item.value === 'commission-deploy') && this.images.length === 0) {
                await this.loadImages();
            }
            if (item.value === 'script-execute' && this.scripts.length === 0) {
                await this.loadScripts();
            }
        }
        await this.service.render();
    }

    public async removeCheckedAction(index: number) {
        this.checkedActions.splice(index, 1);
        await this.service.render();
    }

    public async clearCheckedActions() {
        this.checkedActions = [];
        await this.service.render();
    }

    // ===== Load recent command preset =====
    public async loadPreset(preset: any) {
        this.checkedActions = [];
        for (const actionValue of preset.actions) {
            const item = this.findActionItem(actionValue);
            if (item) {
                this.checkedActions.push({ ...item });
            }
        }
        if (preset.deploy) this.deployForm = { ...preset.deploy };
        if (preset.script_id) this.selectedScriptId = preset.script_id;
        if (this.checkedActions.some((a: any) => a.value === 'deploy' || a.value === 'commission-deploy') && this.images.length === 0) {
            await this.loadImages();
        }
        if (this.checkedActions.some((a: any) => a.value === 'script-execute') && this.scripts.length === 0) {
            await this.loadScripts();
        }
        await this.service.render();
    }

    private selectionParams(): any {
        return {
            include_nodes: JSON.stringify(Array.from(this.includeNodes)),
            include_groups: JSON.stringify(Array.from(this.includeGroups)),
            include_racks: JSON.stringify(Array.from(this.includeRacks)),
            include_clusters: JSON.stringify(Array.from(this.includeClusters)),
            include_zones: JSON.stringify(Array.from(this.includeZones)),
            exclude_nodes: JSON.stringify(Array.from(this.excludeNodes)),
            exclude_groups: JSON.stringify(Array.from(this.excludeGroups)),
            exclude_racks: JSON.stringify(Array.from(this.excludeRacks)),
            exclude_clusters: JSON.stringify(Array.from(this.excludeClusters)),
            exclude_zones: JSON.stringify(Array.from(this.excludeZones)),
        };
    }

    private markSelectionDirty() {
        this.targetResolveToken++;
        this.selectionDirty = true;
        this.resolvedTargetNodes = [];
        this.targetTotal = 0;
        this.step2EnabledNodes.clear();
    }

    private resolveIndividualTargetNodesFromCache(): boolean | null {
        const hasOnlyIndividualIncludes = this.includeNodes.size > 0 &&
            this.includeGroups.size === 0 &&
            this.includeRacks.size === 0 &&
            this.includeClusters.size === 0 &&
            this.includeZones.size === 0 &&
            this.excludeGroups.size === 0 &&
            this.excludeRacks.size === 0 &&
            this.excludeClusters.size === 0 &&
            this.excludeZones.size === 0;
        if (!hasOnlyIndividualIncludes) return null;

        const rows = Array.from(this.includeNodes)
            .map((nodeId: any) => Number(nodeId))
            .filter((nodeId: number) => !this.excludeNodes.has(nodeId))
            .map((nodeId: number) => this.nodeCache[nodeId] || { id: nodeId, name: `Node ${nodeId}`, bmc_ip: '', ip_address: '', rack: '' });

        this.resolvedTargetNodes = rows;
        this.targetTotal = rows.length;
        this.selectionDirty = false;
        return rows.length > 0;
    }

    private async resolveTargetNodes(resolveToken: number = this.targetResolveToken): Promise<boolean> {
        if (!this.selectionDirty && this.resolvedTargetNodes.length > 0) {
            return true;
        }
        const cachedResult = this.resolveIndividualTargetNodesFromCache();
        if (cachedResult !== null) {
            return cachedResult;
        }
        const { code, data } = await wiz.call("nodes", {
            mode: "selection",
            page: 1,
            dump: 5000,
            ...this.selectionParams(),
        });
        if (resolveToken !== this.targetResolveToken) return false;
        if (code !== 200) return false;
        this.resolvedTargetNodes = data.rows || [];
        this.targetTotal = data.total || this.resolvedTargetNodes.length;
        this.cacheNodes(this.resolvedTargetNodes);
        if (data.truncated) {
            alert(`Target node preview is limited to ${this.resolvedTargetNodes.length} nodes. Narrow the selection before execution.`);
            this.selectionDirty = true;
            return false;
        }
        this.selectionDirty = false;
        return this.resolvedTargetNodes.length > 0;
    }

    private findActionItem(value: string): any {
        const normalizedValue = value === 'commission-legacy'
            ? 'commission'
            : value === 'bootdev-none'
                ? 'bootdev-clear'
                : value;
        for (const group of this.actions) {
            for (const item of group.items) {
                if (item.value === normalizedValue) return item;
            }
        }
        return null;
    }

    // ===== Matrix helpers =====
    public async toggleMatrix() {
        this.showMatrix = !this.showMatrix;
        await this.service.render();
    }

    public getMatrixForAction(actionValue: string): any {
        return this.executionMatrix[actionValue] || {};
    }

    public getTransition(actionValue: string): any {
        return this.stateTransitions[actionValue] || null;
    }

    public getCheckedLayers(): string[] {
        const layers = new Set<string>();
        for (const act of this.checkedActions) {
            const matrix = this.executionMatrix[act.value];
            if (matrix) {
                for (const layer of this.matrixLayers) {
                    if (matrix[layer]) layers.add(layer);
                }
            }
        }
        return Array.from(layers);
    }

    // ===== Results summary =====
    public get resultsSummary(): any {
        let totalSuccess = 0;
        let totalFailed = 0;
        let totalNodes = 0;
        for (const ar of this.actionResults) {
            totalSuccess += ar.success || 0;
            totalFailed += ar.failed || 0;
            totalNodes = Math.max(totalNodes, ar.targetCount || (ar.results || []).length);
        }
        return {
            actions: this.actionResults.length,
            totalSuccess,
            totalFailed,
            totalNodes,
            allSuccess: totalFailed === 0 && totalSuccess > 0,
        };
    }

    public getResultIcon(result: any): string {
        if (result.success) return 'bx bx-check-circle';
        if ((result.data || '').includes('Timeout')) return 'bx bx-timer';
        return 'bx bx-x-circle';
    }

    public getResultColor(result: any): string {
        if (result.success) return 'text-green-600';
        if ((result.data || '').includes('Timeout')) return 'text-amber-500';
        return 'text-red-600';
    }

    public getResultBadgeClass(result: any): string {
        if (result.success) return 'bg-green-100 text-green-700';
        if ((result.data || '').includes('Timeout')) return 'bg-amber-100 text-amber-700';
        return 'bg-red-100 text-red-700';
    }

    public getResultBadgeText(result: any): string {
        if (result.worker_started) return 'Started';
        if (result.success) return 'OK';
        if ((result.data || '').includes('Timeout')) return 'Timeout';
        return 'Failed';
    }

    private resultNodeId(result: any, fallbackNodeId: number = 0): number {
        const value = result?.id ?? result?.node_id ?? result?.nodeId ?? fallbackNodeId;
        const nodeId = Number(value);
        return Number.isFinite(nodeId) && nodeId > 0 ? nodeId : 0;
    }

    public getResultNodeLabel(result: any): string {
        const explicitName = String(result?.name || result?.node_name || result?.nodeName || '').trim();
        if (explicitName) return explicitName;
        const nodeId = this.resultNodeId(result);
        return nodeId > 0 ? this.getNodeName(nodeId) : '-';
    }

    private normalizeExecutionResults(code: number, response: any, targets: any[]): any[] {
        const rawResults = code === 200 && Array.isArray(response?.results) ? response.results : [];
        const operations = code === 200 && Array.isArray(response?.operations) ? response.operations : [];
        const resultsByNode = new Map<number, any>();
        const operationsByNode = new Map<number, any>();
        const resultsWithoutNode: any[] = [];

        for (const result of rawResults) {
            if (result?.id == null) {
                resultsWithoutNode.push(result);
                continue;
            }
            resultsByNode.set(Number(result.id), result);
        }
        for (const operation of operations) {
            if (operation?.node_id != null) {
                operationsByNode.set(Number(operation.node_id), operation);
            }
        }

        return targets.map((node: any) => {
            const nodeId = Number(node.id);
            const result = resultsByNode.get(nodeId) || resultsWithoutNode.shift();
            if (result) {
                return {
                    ...result,
                    id: result.id == null ? node.id : result.id,
                    name: result.name || node.name || `Node-${node.id}`,
                };
            }

            const operation = operationsByNode.get(nodeId);
            let message = response?.message || 'Failed to dispatch action to Celery worker';
            if (code === 200 && operation?.id) {
                message = `Celery worker acknowledgement missing for operation #${operation.id}`;
            } else if (code === 200) {
                message = 'Celery worker returned no acknowledgement';
            }
            return {
                id: node.id,
                name: node.name || `Node-${node.id}`,
                success: false,
                worker_started: false,
                operation_id: operation?.id,
                operation_status: operation?.status,
                data: message,
            };
        });
    }

    private requiresFinalResult(actionValue: string): boolean {
        return this.finalResultActions.has(actionValue);
    }

    private async resolveExecutionResults(actionValue: string, code: number, response: any, targets: any[]): Promise<any[]> {
        const initialResults = this.normalizeExecutionResults(code, response, targets);
        const operations = code === 200 && Array.isArray(response?.operations) ? response.operations : [];
        if (!this.requiresFinalResult(actionValue) || operations.length === 0) {
            return initialResults;
        }
        return await this.waitForOperations(operations, initialResults);
    }

    private buildExecutionPayload(actionValue: string, nodeIds: number[]): any {
        const payload: any = {
            action: actionValue,
            include_nodes: JSON.stringify(nodeIds),
            include_groups: JSON.stringify([]),
            include_racks: JSON.stringify([]),
            include_clusters: JSON.stringify([]),
            include_zones: JSON.stringify([]),
            exclude_nodes: JSON.stringify([]),
            exclude_groups: JSON.stringify([]),
            exclude_racks: JSON.stringify([]),
            exclude_clusters: JSON.stringify([]),
            exclude_zones: JSON.stringify([]),
        };
        if (actionValue === 'deploy' || actionValue === 'commission-deploy') {
            payload.deploy = JSON.stringify(this.deployForm);
        }
        if (actionValue === 'script-execute') {
            payload.extra = JSON.stringify({ script_id: this.selectedScriptId });
        }
        return payload;
    }

    public async confirmRetryFailedActions() {
        if (this.isRunning) return;
        const failedCount = this.actionResults.reduce((count: number, actionResult: any) => (
            count + (actionResult.results || []).filter((row: any) => !row.success).length
        ), 0);
        if (failedCount === 0) return;
        const confirmed = confirm(this.translate.instant('page.actions.confirm_retry_failed', { count: failedCount }));
        if (!confirmed) return;
        await this.retryFailedActions();
    }

    private async retryFailedActions() {
        this.isRunning = true;
        await this.service.render();
        try {
            for (const actionResult of this.actionResults) {
                const failedRows = (actionResult.results || []).filter((row: any) => !row.success);
                if (failedRows.length === 0) continue;

                const failedNodeIds = failedRows.map((row: any) => Number(row.id));
                const retryTargets = failedRows.map((row: any) => ({ id: Number(row.id), name: row.name }));
                const payload = {
                    ...(actionResult.requestPayload || this.buildExecutionPayload(actionResult.value, failedNodeIds)),
                    include_nodes: JSON.stringify(failedNodeIds),
                };
                this.currentRunningAction = `${actionResult.action} (Retry Failed Only)`;
                this.currentRunningIndex = Math.max(0, Number(actionResult.order || 1) - 1);
                await this.service.render();

                const { code, data } = await wiz.call('execute', payload);
                const response = data || {};
                const retryResults = await this.resolveExecutionResults(actionResult.value, code, response, retryTargets);
                const retryByNode = new Map<number, any>();
                for (const row of retryResults) retryByNode.set(Number(row.id), row);

                actionResult.results = (actionResult.results || []).map((row: any) => (
                    row.success ? row : (retryByNode.get(Number(row.id)) || row)
                ));
                actionResult.operations = [
                    ...(actionResult.operations || []),
                    ...(code === 200 ? (response.operations || []) : []),
                ];
                actionResult.retryAttempted = true;
                actionResult.success = actionResult.results.filter((row: any) => row.success).length;
                actionResult.failed = actionResult.results.filter((row: any) => !row.success).length;
                await this.service.render();
            }
        } finally {
            this.isRunning = false;
            this.currentRunningAction = '';
            this.currentRunningIndex = -1;
            await this.service.render();
        }
    }

    private sleep(ms: number): Promise<void> {
        return new Promise((resolve) => setTimeout(resolve, ms));
    }

    private rowsFromOperationTask(task: any): any[] {
        const taskResult = task?.result || {};
        const rows = Array.isArray(taskResult.results) ? taskResult.results : [];
        if (rows.length > 0) {
            return rows.map((row: any) => {
                const nodeId = this.resultNodeId(row, Number(task?.node_id || 0));
                const normalized = { ...row, id: nodeId || row?.id };
                return {
                    ...normalized,
                    name: this.getResultNodeLabel(normalized),
                    operation_id: undefined,
                    operation_status: undefined,
                    queued: false,
                    duplicate: false,
                };
            });
        }
        return [{
            id: task?.node_id,
            name: this.getNodeName(Number(task?.node_id || 0)),
            success: task?.status === 'completed',
            data: task?.error || taskResult.message || task?.status || '-',
            operation_id: undefined,
            operation_status: undefined,
            queued: false,
            duplicate: false,
        }];
    }

    private async waitForOperations(operations: any[], initialResults: any[]): Promise<any[]> {
        if (!operations || operations.length === 0) return initialResults || [];
        const pending = new Map<number, any>();
        for (const op of operations) {
            if (op?.id) pending.set(Number(op.id), op);
        }
        const completedRows: any[] = [];
        const deadline = Date.now() + (60 * 60 * 1000);
        while (pending.size > 0 && Date.now() < deadline) {
            for (const operationId of Array.from(pending.keys())) {
                const { code, data } = await wiz.call('operation_get', { id: operationId });
                if (code !== 200 || !data?.task) continue;
                const task = data.task;
                if (task.status === 'completed') {
                    completedRows.push(...this.rowsFromOperationTask(task));
                    pending.delete(operationId);
                } else if (['failed', 'cancelled', 'review-needed'].includes(task.status)) {
                    completedRows.push(...this.rowsFromOperationTask(task));
                    pending.delete(operationId);
                }
            }
            await this.service.render();
            if (pending.size > 0) {
                await this.sleep(3000);
            }
        }
        for (const op of pending.values()) {
            completedRows.push({
                id: op.node_id,
                name: this.getNodeName(Number(op.node_id || 0)),
                success: false,
                data: 'Timeout waiting for operation result',
            });
        }
        return completedRows;
    }

    // ===== Group helpers =====
    public getRacksForGroup(groupId: number): any[] {
        return this.groupRacks[groupId] || [];
    }

    public getNodeCountForGroup(groupId: number): number {
        const group = this.groups.find((g: any) => g.id === groupId);
        return group ? Number(group.node_count || 0) : 0;
    }

    public getNodeCountForRack(rack: string): number {
        let count = 0;
        for (const key of Object.keys(this.groupRacks)) {
            const rows = this.groupRacks[key] || [];
            const match = (rows || []).find((item: any) => (
                String(item.key || item.rack) === String(rack)
            ));
            if (match) count += Number(match.count || 0);
        }
        return count;
    }

    // ===== Group Include/Exclude =====
    public getGroupState(groupId: number): string {
        if (this.includeGroups.has(groupId)) return 'include';
        if (this.excludeGroups.has(groupId)) return 'exclude';
        return 'none';
    }

    public async setGroupInclude(groupId: number) {
        if (this.includeGroups.has(groupId)) {
            this.includeGroups.delete(groupId);
        } else {
            this.excludeGroups.delete(groupId);
            this.includeGroups.add(groupId);
        }
        this.markSelectionDirty();
        await this.service.render();
    }

    public async setGroupExclude(groupId: number) {
        if (this.excludeGroups.has(groupId)) {
            this.excludeGroups.delete(groupId);
        } else {
            this.includeGroups.delete(groupId);
            this.excludeGroups.add(groupId);
        }
        this.markSelectionDirty();
        await this.service.render();
    }

    public async toggleGroupExpand(groupId: number) {
        if (this.expandedGroups.has(groupId)) {
            this.expandedGroups.delete(groupId);
        } else {
            this.expandedGroups.add(groupId);
            if (!this.groupRacks[groupId]) {
                const { code, data } = await wiz.call("nodes", { mode: "racks", group_id: groupId });
                if (code === 200) this.groupRacks[groupId] = data.rows || [];
            }
        }
        await this.service.render();
    }

    // ===== Rack Include/Exclude =====
    public getRackState(rack: string): string {
        if (this.includeRacks.has(rack)) return 'include';
        if (this.excludeRacks.has(rack)) return 'exclude';
        return 'none';
    }

    public async setRackInclude(rack: string) {
        if (this.includeRacks.has(rack)) {
            this.includeRacks.delete(rack);
        } else {
            this.excludeRacks.delete(rack);
            this.includeRacks.add(rack);
        }
        this.markSelectionDirty();
        await this.service.render();
    }

    public async setRackExclude(rack: string) {
        if (this.excludeRacks.has(rack)) {
            this.excludeRacks.delete(rack);
        } else {
            this.includeRacks.delete(rack);
            this.excludeRacks.add(rack);
        }
        this.markSelectionDirty();
        await this.service.render();
    }

    // ===== Cluster / Zone Include/Exclude =====
    public getClusterState(clusterId: number): string {
        if (this.includeClusters.has(clusterId)) return 'include';
        if (this.excludeClusters.has(clusterId)) return 'exclude';
        return 'none';
    }

    public async setClusterInclude(clusterId: number) {
        if (this.includeClusters.has(clusterId)) {
            this.includeClusters.delete(clusterId);
        } else {
            this.excludeClusters.delete(clusterId);
            this.includeClusters.add(clusterId);
        }
        this.markSelectionDirty();
        await this.service.render();
    }

    public async setClusterExclude(clusterId: number) {
        if (this.excludeClusters.has(clusterId)) {
            this.excludeClusters.delete(clusterId);
        } else {
            this.includeClusters.delete(clusterId);
            this.excludeClusters.add(clusterId);
        }
        this.markSelectionDirty();
        await this.service.render();
    }

    public getZoneState(zoneId: number): string {
        if (this.includeZones.has(zoneId)) return 'include';
        if (this.excludeZones.has(zoneId)) return 'exclude';
        return 'none';
    }

    public async setZoneInclude(zoneId: number) {
        if (this.includeZones.has(zoneId)) {
            this.includeZones.delete(zoneId);
        } else {
            this.excludeZones.delete(zoneId);
            this.includeZones.add(zoneId);
        }
        this.markSelectionDirty();
        await this.service.render();
    }

    public async setZoneExclude(zoneId: number) {
        if (this.excludeZones.has(zoneId)) {
            this.excludeZones.delete(zoneId);
        } else {
            this.includeZones.delete(zoneId);
            this.excludeZones.add(zoneId);
        }
        this.markSelectionDirty();
        await this.service.render();
    }

    // ===== Node Include/Exclude =====
    public getNodeState(nodeId: number): string {
        if (this.includeNodes.has(nodeId)) return 'include';
        if (this.excludeNodes.has(nodeId)) return 'exclude';
        return 'none';
    }

    public async setNodeInclude(nodeId: number) {
        if (this.includeNodes.has(nodeId)) {
            this.includeNodes.delete(nodeId);
        } else {
            this.excludeNodes.delete(nodeId);
            this.includeNodes.add(nodeId);
        }
        this.markSelectionDirty();
        await this.service.render();
    }

    public async setNodeExclude(nodeId: number) {
        if (this.excludeNodes.has(nodeId)) {
            this.excludeNodes.delete(nodeId);
        } else {
            this.includeNodes.delete(nodeId);
            this.excludeNodes.add(nodeId);
        }
        this.markSelectionDirty();
        await this.service.render();
    }

    // ===== Remove helpers =====
    public async removeIncludedGroup(groupId: number) {
        this.includeGroups.delete(groupId);
        this.expandedGroups.delete(groupId);
        const racks = this.getRacksForGroup(groupId);
        for (const rack of racks) {
            const rackKey = String(rack.key || rack.rack);
            this.includeRacks.delete(rackKey);
            this.excludeRacks.delete(rackKey);
        }
        this.markSelectionDirty();
        await this.service.render();
    }

    public async removeExcludedGroup(groupId: number) {
        this.excludeGroups.delete(groupId);
        this.markSelectionDirty();
        await this.service.render();
    }

    public async removeIncludedRack(rack: string) {
        this.includeRacks.delete(rack);
        this.markSelectionDirty();
        await this.service.render();
    }

    public async removeExcludedRack(rack: string) {
        this.excludeRacks.delete(rack);
        this.markSelectionDirty();
        await this.service.render();
    }

    public async removeIncludedCluster(clusterId: number) {
        this.includeClusters.delete(clusterId);
        this.markSelectionDirty();
        await this.service.render();
    }

    public async removeExcludedCluster(clusterId: number) {
        this.excludeClusters.delete(clusterId);
        this.markSelectionDirty();
        await this.service.render();
    }

    public async removeIncludedZone(zoneId: number) {
        this.includeZones.delete(zoneId);
        this.markSelectionDirty();
        await this.service.render();
    }

    public async removeExcludedZone(zoneId: number) {
        this.excludeZones.delete(zoneId);
        this.markSelectionDirty();
        await this.service.render();
    }

    public async removeIncludedNode(nodeId: number) {
        this.includeNodes.delete(nodeId);
        this.markSelectionDirty();
        await this.service.render();
    }

    public async removeExcludedNode(nodeId: number) {
        this.excludeNodes.delete(nodeId);
        this.markSelectionDirty();
        await this.service.render();
    }

    // ===== Target Nodes (priority: node > rack > group) =====
    public get targetNodes(): any[] {
        return this.resolvedTargetNodes;
    }

    public get targetCount(): number {
        return this.targetTotal || this.resolvedTargetNodes.length;
    }

    public get filteredNodes(): any[] {
        return this.allNodes;
    }

    public async switchTab(tab: string) {
        this.nodeTab = tab;
        await this.service.render();
    }

    public get hasAnySelection(): boolean {
        return this.includeGroups.size > 0 || this.excludeGroups.size > 0 ||
            this.includeRacks.size > 0 || this.excludeRacks.size > 0 ||
            this.includeClusters.size > 0 || this.excludeClusters.size > 0 ||
            this.includeZones.size > 0 || this.excludeZones.size > 0 ||
            this.includeNodes.size > 0 || this.excludeNodes.size > 0;
    }

    // ===== Execute (ordered actions, parallel target nodes) =====
    public async executeActions() {
        if (this.isResolvingTargets) return;
        if (this.checkedActions.length === 0) return;

        const targets = this.step2ActiveNodes;
        if (targets.length === 0) return;

        const actionLabels = this.checkedActions.map((a: any) => a.label).join(' → ');
        const confirmed = confirm(this.translate.instant('page.actions.confirm_execute', { actions: actionLabels, count: targets.length }));
        if (!confirmed) return;

        this.isRunning = true;
        this.actionResults = [];
        await this.service.render();

        const nodeIds = targets.map((n: any) => n.id);

        for (let i = 0; i < this.checkedActions.length; i++) {
            const action = this.checkedActions[i];
            this.currentRunningAction = action.label;
            this.currentRunningIndex = i;
            await this.service.render();

            const payload = this.buildExecutionPayload(action.value, nodeIds);

            const { code, data } = await wiz.call("execute", payload);
            const response = data || {};
            const results = await this.resolveExecutionResults(action.value, code, response, targets);
            const operations = code === 200 ? (response.operations || []) : [];

            this.actionResults.push({
                action: action.label,
                value: action.value,
                order: i + 1,
                targetCount: targets.length,
                results: results,
                operations: operations,
                requestPayload: payload,
                executionMode: response.execution_mode || 'queued',
                finalResult: this.requiresFinalResult(action.value),
                success: results.filter((r: any) => r.success).length,
                failed: results.filter((r: any) => !r.success).length,
            });
            await this.service.render();
        }

        this.isRunning = false;
        this.currentRunningAction = '';
        this.currentRunningIndex = -1;
        await this.service.render();

        // Save to recent commands
        await this.saveRecentCommand();
        if (this.resultsSummary.totalFailed > 0) {
            await this.confirmRetryFailedActions();
        }
    }

    private async saveRecentCommand() {
        const actionValues = this.checkedActions.map((a: any) => a.value);
        const payload: any = {
            actions: JSON.stringify(actionValues),
        };
        if (actionValues.includes('deploy') || actionValues.includes('commission-deploy')) {
            payload.deploy = JSON.stringify(this.deployForm);
        }
        if (actionValues.includes('script-execute')) {
            payload.script_id = this.selectedScriptId;
        }
        const { code, data } = await wiz.call("save_recent_command", payload);
        if (code === 200) {
            this.recentCommands = data.commands || [];
            await this.service.render();
        }
    }

    // ===== Clear =====
    public async clearSelection() {
        this.includeGroups.clear();
        this.excludeGroups.clear();
        this.includeRacks.clear();
        this.excludeRacks.clear();
        this.includeClusters.clear();
        this.excludeClusters.clear();
        this.includeZones.clear();
        this.excludeZones.clear();
        this.includeNodes.clear();
        this.excludeNodes.clear();
        this.expandedGroups.clear();
        this.markSelectionDirty();
        await this.service.render();
    }

    // ===== Status helpers =====
    public getStatusColor(status: string): string {
        switch (status) {
            case 'new': return 'bg-zinc-500';
            case 'ready': return 'bg-green-500';
            case 'deploying': return 'bg-yellow-500';
            case 'deployed': return 'bg-blue-500';
            case 'commissioning': return 'bg-violet-500';
            case 'backing-up': return 'bg-amber-500';
            case 'error': case 'failed': return 'bg-red-500';
            case 'on': return 'bg-green-500';
            case 'off': return 'bg-zinc-400';
            default: return 'bg-zinc-400';
        }
    }

    public getGroupName(groupId: number): string {
        const g = this.groups.find((g: any) => g.id === groupId);
        return g ? g.name : `Group ${groupId}`;
    }

    public getNodeName(nodeId: number): string {
        const n = this.nodeCache[Number(nodeId)] || this.allNodes.find((n: any) => n.id === nodeId);
        return String(n?.name || '').trim() || `Node ${nodeId}`;
    }

    public getRackLabel(rackKey: string): string {
        for (const groupId of Object.keys(this.groupRacks)) {
            const rack = (this.groupRacks[groupId] || []).find(
                (item: any) => String(item.key || item.rack) === String(rackKey)
            );
            if (rack) {
                const groupName = this.getGroupName(Number(groupId));
                return `${groupName} / Rack ${rack.rack}`;
            }
        }
        return `Rack ${rackKey}`;
    }

    public getClusterName(clusterId: number): string {
        const cluster = this.clusters.find(
            (item: any) => Number(item.id) === Number(clusterId)
        );
        return cluster ? cluster.name : `Cluster ${clusterId}`;
    }

    public getZoneName(zoneId: number): string {
        const zone = this.zones.find(
            (item: any) => Number(item.id) === Number(zoneId)
        );
        return zone ? zone.name : `Zone ${zoneId}`;
    }

    public getActionLabel(value: string): string {
        const item = this.findActionItem(value);
        return item ? item.label : value;
    }
}

export default PageKieraActionsComponent;
